import { Switch } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { SubNavBar, SubNavBarButton } from "./@Shared/SubNavBar";
import { store } from "Store";
import { ProposalsUI } from "./Feedback/ProposalsUI";
export class FeedbackUI extends BaseComponentPlus({}, {}) {
    render() {
        const currentSubpage = store.main.feedback.subpage;
        const page = "feedback";
        return (React.createElement(React.Fragment, null,
            React.createElement(SubNavBar, null,
                React.createElement(SubNavBarButton, { page: page, subpage: "proposals", text: "Proposals", actionFuncIfAlreadyActive: s => s.feedback.main.proposals.selectedProposalID = null })),
            React.createElement(Switch, null,
                React.createElement(ProposalsUI, null))));
    }
}
